export default __webpack_public_path__ + "static/media/draft-setting.7ac3b11d.png";